import React from "react";

export const Brands = Object.freeze({
	STANLEY: "Stanley",
	BLACK_AND_DECKER: "Black and Decker",
	DEWALT: "DeWalt",
	IRWIN: "Irwin",
	CRAFTSMAN: "Craftsman",
	BOSTITCH: "Bostitch",
	LENOX: "Lenox",
	PORTER_CABLE: "Porter Cable",
});

export const Languages = Object.freeze({
	ENGLISH: "en",
	SPANISH: "es",
	PORTUGUESE: "pt",
	BR_PORTUGUESE: "pt-br",
	TURKISH: "tr",
	KOREAN: "ko",
	JAPANESE: "ja",
	THAILAND: "th",
	IDN_BAHASA: "id",
	MLY_BAHASA: "ms",
	CHINESE: "zh",
	ARABIC: "ar",
	VIETNAMESE: "vi",
	DEUTSCH: "de",
});

export const MAX_COMMENT_LENGTH = 300;

export const themes = {
	[Brands.STANLEY.toLowerCase()]: {
		backgroundColor: "#fbd504",
		buttonBackground: "#fbd504",
		logoPath: "",
		buttonTextColor: "#000",
	},
	[Brands.BLACK_AND_DECKER.toLowerCase()]: {
		backgroundColor: "#000",
		color: "#E25F26",
		// buttonBackground: "#E25F26",
		buttonBackground: "#000",
		// buttonTextColor: "#fff",
		buttonTextColor: "#E25F26",
		logoPath: "",
	},
	[Brands.DEWALT.toLowerCase()]: {
		backgroundColor: "#000000",
		color: "#FEBC18",
		buttonBackground: "#000000",
		buttonTextColor: "#FEBC18",
		logoPath: "",
	},
	[Brands.IRWIN.toLocaleLowerCase()]: {
		backgroundColor: "#000B6D",
		buttonBackground: "#000B6D",
		buttonTextColor: "#FFC528",
	},
	[Brands.CRAFTSMAN.toLocaleLowerCase()]: {
		backgroundColor: "#D6001C",
		buttonBackground: "#D6001C",
		buttonTextColor: "#FFFFFF",
	},
	[Brands.LENOX.toLocaleLowerCase()]: {
		backgroundColor: "#FFFFFF",
		buttonBackground: "#0039AA",
		buttonTextColor: "#FFFFFF",
	},
	[Brands.BOSTITCH.toLocaleLowerCase()]: {
		backgroundColor: "#000000",
		buttonBackground: "#000000",
		buttonTextColor: "#FFFFFF",
	},
	[Brands.PORTER_CABLE.toLocaleLowerCase()]: {
		backgroundColor: "#000000",
		buttonBackground: "#000000",
		buttonTextColor: "#FFFFFF",
	},
};

export const BrandContext = React.createContext({
	name: Brands.STANLEY,
	theme: themes.stanley,
	toggleTheme: () => {},
});

export const LanguageContext = React.createContext({
	language: Languages.ENGLISH,
	setLanguage: () => {},
});

const normalizeBrandName = (brandName) => {
	const searchRegExp = / /g;
	const replaceWith = "_";
	brandName = brandName.replace(searchRegExp, replaceWith);
	brandName = brandName.toLowerCase();
	return brandName;
};

export const getBrandLogoUrl = (brandName) => {
	brandName = normalizeBrandName(brandName);
	return "../images/" + brandName + ".png";
};

export const getBrandLogo = (brandName) => {
	brandName = normalizeBrandName(brandName);
	let brandLogo;
	try {
		brandLogo = require("../images/" + brandName + ".png");
	} catch (e) {
		brandLogo = require("../images/stanley.png");
	}
	return brandLogo;
};
